// extracted by mini-css-extract-plugin
module.exports = {"columnButton":"Firms_columnButton___cgHl","separator":"Firms_separator__V6XiW"};